

  import {Component, Vue} from "vue-property-decorator";
  import AuditTabPane from "../components/AuditTabPane.vue";
  import api from '@/api';
  import {AuditUserLogType} from "@/api/appService";

  @Component({name:'AuditTabOfActivity',
    components: {AuditTabPane}
  })
  export default class AuditTabOfActivity extends Vue{

    fetchData(){
      return api.activity.getMyAll;
    }

    getHostType(dto:any){
      return AuditUserLogType.ActivityPublish;
    }

    audit(){
      return api.activity.audit;
    }

    handleCountChange(value:number){
      this.$emit('count-changed',value);
    }

  }
